import { Badge } from "@mui/material";
import Link, { LinkProps } from "@mui/material/Link";
import MuiTable from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TextField from "@mui/material/TextField";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { LinkProps as RouterLinkProps } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  /* margin: ${({ theme }) => theme.spacing(1, 0)}; */
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${({ theme }) => theme.spacing(2, 0)};
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const SearchTextField = styled(TextField)`
  margin-left: auto;
`;

export const NoDataText = styled(Typography)`
  text-align: center;
`;

export const Table = styled(MuiTable)`
  table-layout: fixed;
  width: 100%;

  /* & :last-child .MuiTableRow-root:last-child .MuiTableCell-root {
    border-bottom: none;
  } */

  & th {
    background-color: ${({ theme }) =>
      theme.palette.mode === "dark"
        ? theme.palette.grey[900]
        : theme.palette.grey[100]};
  }
`;

export const TableCellText = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-line;
  overflow-wrap: break-word;
  word-break: normal;
`;

export const TableTotalCellText = styled(TableCellText)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const BadgeStyled = styled(Badge)`
  margin-left: ${({ theme }) => theme.spacing(15)};
`;

export const TableCellTextDisabled = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.disabled};
  font-size: 0.9rem;
`;

export const ActionsTableCell = styled(TableCell)`
  width: ${({ theme }) => theme.spacing(6)};
`;

export const LoaderContainer = styled.div`
  height: ${({ theme }) => theme.spacing(20)};
`;

export const TableLink = styled(Link)<LinkProps & RouterLinkProps>`
  /* text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap; */
  display: block;
  overflow-wrap: break-word;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: ${({ theme }) => theme.spacing(1)};
`;

export const TablePagination = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: ${({ theme }) => theme.spacing(-1)};
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* margin-bottom: ${({ theme }) => theme.spacing(2)}; */
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const Title = styled(Typography)<
  TypographyProps<"h2", { component: "h2" }>
>`
  margin-right: ${({ theme }) => theme.spacing(2)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const TabsContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const IconContainer = styled.span`
  display: flex;
  margin-right: ${({ theme }) => theme.spacing(1)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledChipSpan = styled.span`
  margin: ${({ theme }) => theme.spacing(0.5)};
  border-radius: 50%;
  padding: ${({ theme }) => theme.spacing(1, 1.5)};
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100]};
`;

export const Description = styled(Typography)`
  margin: ${({ theme }) => theme.spacing(1, 1, 1, 0)};
  /* color: ${({ theme }) => theme.palette.text.secondary}; */
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  font-size: 0.9rem;
`;

export const TableCellTextWithMargin = styled(TableCellText)`
  margin-left: ${({ theme }) => theme.spacing(0.5)};
`;
